import { createContext, PropsWithChildren } from 'react';

type WorkloadDetailsContextValue = {
  name: string;
  controller: string;
  namespace: string;
};

const WorkloadDetailsContext = createContext<WorkloadDetailsContextValue>(
  {} as never
);

type Props = WorkloadDetailsContextValue;

export const WorkloadDetailsProvider = ({
  children,
  name,
  controller,
  namespace,
}: PropsWithChildren<Props>) => {
  return (
    <WorkloadDetailsContext.Provider
      value={{
        name,
        controller,
        namespace,
      }}
    >
      {children}
    </WorkloadDetailsContext.Provider>
  );
};
